import { useMemo } from 'react';
import {
  useCheckPermissions as libUseCheckPermissions,
  PermissionCheck as LibPermissionCheck,
  PermissionsProvider as LibPermissionsProvider,
} from 'react-permissions-dynamic';
import type {
  PermissionCheckProps as LibPermissionCheckProps,
  PermissionsProviderProps as LibPermissionsProviderProps,
} from 'react-permissions-dynamic';

type PermissionCheckProps = LibPermissionCheckProps<PermissionType> & {
  type?: 'every' | 'some';
};
type PermissionsProviderProps = LibPermissionsProviderProps<PermissionType>;

const PermissionCheck: React.FC<PermissionCheckProps> = ({
  type = 'every',
  ...props
}) => {
  const action = Array.isArray(props.action) ? props.action : [props.action];
  const flattenedAction = action.flat();

  return (
    <LibPermissionCheck
      {...props}
      action={flattenedAction}
      isAllowed={(allowed, denied) =>
        type === 'every'
          ? !denied.length
          : !action.length || allowed.some(c => !!c)
      }
    />
  );
};
const PermissionsProvider =
  LibPermissionsProvider as React.FC<PermissionsProviderProps>;

export { PermissionCheck, PermissionsProvider };
export const useCheckPermissions = (
  actions: PermissionType[] | PermissionType
) => {
  const actionsArray = Array.isArray(actions) ? actions : [actions];
  return libUseCheckPermissions(Array.from(new Set(actionsArray)));
};

export const useAllowed = (actions: (PermissionType | undefined)[]) => {
  const filtered = actions.filter(Boolean) as PermissionType[];
  const results = libUseCheckPermissions<PermissionType>(filtered);
  return useMemo(
    () => results.filter(r => r.allowed).map(r => r.action as PermissionType),
    [results]
  );
};
